import { useMemo } from "react";
import { useLocation } from "react-router";
import { MOBILE_SLIDER_PAGES_IDS } from "./mobileSliderPagesConstants.js";
import { Offcanvas } from "react-bootstrap";
import SlideMobileRegisterEmailCheck from "./slides/SlideMobileRegisterEmailCheck/SlideMobileRegisterEmailCheck";
import SlideMobileOpenMobileApp from "./slides/SlideMobileOpenMobileApp";

const MOBILE_SLIDER_PAGES_COMPONENTS = {
    [MOBILE_SLIDER_PAGES_IDS.OPEN_MOBILE_APP]: SlideMobileOpenMobileApp,
    [MOBILE_SLIDER_PAGES_IDS.REGISTER_EMAIL_CHECK]: SlideMobileRegisterEmailCheck,
}

const mobileSliderPagesComponentsList = Object.entries(MOBILE_SLIDER_PAGES_COMPONENTS);

function MobileSliderPages() {
    const {search} = useLocation();

    const [openedPageId] = useMemo(() => {
        const params = new URLSearchParams(search);
        const openedPageId = params.get('s');
        return [openedPageId];
    }, [search]);

    return mobileSliderPagesComponentsList.map(([pageId, Component]) => (
        <Offcanvas key={pageId} show={openedPageId === pageId} placement="end" style={{width: "100%"}}>
            <Component/>
        </Offcanvas>
    ))
}

export default MobileSliderPages;
